const collections = [
  { label: '暑期档热映', desc: '多部国产大片同期上线', icon: 'ri-sun-line', accent: true },
  { label: '高分悬疑剧场', desc: '烧脑反转扣人心弦', icon: 'ri-magic-line', accent: false },
  { label: '经典港片回顾', desc: '重温黄金年代记忆', icon: 'ri-vidicon-line', accent: false },
  { label: '韩剧热门精选', desc: '高甜虐恋一次看过瘾', icon: 'ri-heart-line', accent: false },
  { label: '国产动画崛起', desc: '精品国漫持续更新', icon: 'ri-rocket-line', accent: false },
  { label: '纪录片之窗', desc: '探索真实世界的精彩', icon: 'ri-earth-line', accent: false },
  { label: '科幻巨制合集', desc: '脑洞大开视觉盛宴', icon: 'ri-planet-line', accent: false },
  { label: '喜剧爆笑专场', desc: '承包你所有的笑点', icon: 'ri-emotion-laugh-line', accent: false },
  { label: '午夜惊悚系列', desc: '胆量挑战就趁现在', icon: 'ri-ghost-line', accent: false },
];

export default function IndexSection() {
  return (
    <section id="index" className="bg-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block text-xs font-semibold uppercase tracking-widest text-primary-400 mb-3">COLLECTIONS</span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50">专题合集</h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-[500px] mx-auto">按主题精选的影视专题，方便你快速找到心仪内容</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {collections.map((c, i) => (
              <div
                key={i}
                className={`group flex items-center gap-4 rounded-xl p-5 border transition-all duration-300 cursor-pointer ${
                  c.accent
                    ? 'bg-accent-500/5 border-accent-500/15 hover:bg-accent-500/10'
                    : 'bg-background-100 border-background-200/40 hover:border-primary-500/20 hover:bg-background-200/60'
                }`}
              >
                <div className={`w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0 transition-colors duration-300 ${
                  c.accent ? 'bg-accent-500/15 text-accent-400' : 'bg-primary-500/10 text-primary-400 group-hover:bg-primary-500/20'
                }`}>
                  <i className={`${c.icon} text-lg`}></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-100 mb-1">{c.label}</h3>
                  <p className="text-xs text-foreground-500">{c.desc}</p>
                </div>
                <div className="ml-auto">
                  <i className="ri-arrow-right-s-line text-foreground-600 group-hover:text-primary-400 transition-colors duration-200"></i>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}